import React from 'react';
import Content from '@common/content';
import Footer from '@common/footer';
import Header from '@common/header';
import Layout from '@common/layout';
import { JobdaDeclarationCustomHead } from '@common/customHead';
import Declaration from '@components/declaration';

const DeclarationPage = () => {
  return (
    <Layout>
      <JobdaDeclarationCustomHead />
      <Header />
      <Content>
        <Declaration />
      </Content>
      <Footer />
    </Layout>
  );
};

export default DeclarationPage;
